import AreaMeasurer from './AreaMeasurer';

export default AreaMeasurer;